import { useContext } from "react";

import { Button } from "@/components/common/Button";
import { useModal } from "@/hooks/common/use-modal";
import { formatDateInSaoPauloTimeZone } from "@/utils/date";

import { RescheduleCandidateModal } from "../../RescheduleCandidateModal";
import { ReschedulePhotoRenewalModal } from "../../ReschedulePhotoRenewalModal";
import { ScheduleActionsContext } from "../Provider";

export const ScheduleActionsReschedule = () => {
  const modal = useModal();
  const { schedule } = useContext(ScheduleActionsContext);
  const canReschedule =
    (schedule.scheduleType === "NEW_CANDIDATE" || schedule.scheduleType === "PHOTO_RENEWAL") &&
    schedule.status === "AWAITING" &&
    schedule.currentStage === "SCHEDULED" &&
    !schedule.isPresent &&
    Boolean(schedule.scheduleDate) &&
    formatDateInSaoPauloTimeZone(new Date(schedule.scheduleDate!)) >= formatDateInSaoPauloTimeZone();

  if (!canReschedule) {
    return null;
  }

  return (
    <>
      <Button variant="secondary" full onClick={modal.openModal}>
        <span className="font-regular">Reagendar atendimento</span>
      </Button>
      {schedule.scheduleType === "PHOTO_RENEWAL" ? (
        <ReschedulePhotoRenewalModal isOpen={modal.isModalOpen} onClose={modal.closeModal} schedule={schedule} />
      ) : (
        <RescheduleCandidateModal isOpen={modal.isModalOpen} onClose={modal.closeModal} schedule={schedule} />
      )}
    </>
  );
};
